<div class="productCommonFeatureEditDialog">
    <div class="allFeatures">
        <div class="dis-flx">
            <h3>Verfügbare übergeordnete Auswahlkriterien</h3>            
            <mat-icon
            matSuffix
            class="info-tooltip-icon"
            color="primary"
            matTooltipClass="tooltip"
            matTooltip="Für mit einem Stern (*) gekennzeichnete Kriterien muss mindestens eine Auswahl getroffen werden, um das Produkt zu speichern."
            matTooltipPosition="above"
            tabindex="-1"
            >
            info_outline
            </mat-icon>
        </div>
        <div class="availableFeatureContainer">
            <mat-accordion>
                @for (feature of availableCommonFeatures; track $index) {
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                {{ feature.name }}
                                <span *ngIf="isFeatureRequired(feature)">*</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div>
                            <div *ngFor="let entry of feature.featureEntries">
                                <mat-checkbox
                                [checked]="isEntrySelected(feature, entry)"
                                (change)="onEntryToggle(feature, entry, $event.checked)"
                                >
                                {{ entry.name }}
                                </mat-checkbox>
                            </div>
                        </div>
                    </mat-expansion-panel>
                }
            </mat-accordion>
        </div>
    </div>

    <div class="selectedFeatures">
        <h3>Ausgewählte übergeordnete Auswahlkriterien</h3>
        <div class="selectedFeatureContainer">
            <mat-accordion>
                @for (group of groupedSelectedFeaturesArray; track $index) {
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                {{ group.featureName }}
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        @for (entry of group.entries; track $index) {
                            <div class="selectedFeatureEntry">
                            <span>{{ entry.name }}</span>
                                <red-cross-button-circle
                                    (press)="removeSelectedFeatureByFeatureAndEntry(group.featureId, entry.id)">
                                </red-cross-button-circle>
                            </div>
                        }
                    </mat-expansion-panel>
                }
            </mat-accordion>
        </div>
    </div>
</div>
